import Endpoints from "../config/endpoints"
import Request from "../helpers/request";

export default class ProductRequests {

    static search(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.product.search, filter, {}, true)
    }

    static get(code) {
        return Request
            .getInstance()
            .createGetRequest(`${Endpoints.product.get}/${code}`, {includeReleases: true}, {}, true)
            .then(res=> !!res ? res.data : null )
    }
}



// WEBPACK FOOTER //
// ./src/requests/product-requests.js